import React, {useState} from 'react'
import Partnerts from '../../images/minecraft_partner.png'
import Creative from '../../images/aliquam_creative.png'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'
import Minecraft from '../../images/Minecraft-Logo.png'

const SomeText = () => {
    const [counterOn, setCounterOn] = useState(false)

  return (
    <div className="container-text">
        <div className='container-text-left'>
            <h1>Official <a href="https://www.minecraft.net/"><img src={Minecraft} alt='Minecraft'/></a> Partners</h1>
            <p>We have become official Minecraft partners in 2022. Working together with the best developers and designers in the business, we strive to release quality content on Minecraft Marketplace. Our Maps come in a wide variety of themes and storylines.</p>
        <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
            <div className="statistics">
                <div className='statistics-elements'>
                    <h3>Products</h3>
                    <p>
                        +{counterOn && <CountUp start={0} end={75} duration={2.5} delay={0.25}/> }
                    </p>
                </div>
                <div className='statistics-elements'>
                    <h3>Downloads</h3>
                    <p>
                        +{counterOn && <CountUp start={0} end={76000} duration={4.5} delay={0.25}/>}
                    </p>
                </div>
                <div className='statistics-elements'>
                    <h3>Partners and friends</h3>
                    <a href="https://www.planetminecraft.com/server/aliquam/" target="_blank" rel="noreferrer">
                        <img src={Creative} alt="Aliquam Creative" className='alq-creative'/>
                    </a>
                </div>
            </div>
        </ScrollTrigger>
        </div>
        <div  className='container-text-right'>
            <a href="https://www.minecraft.net/en-us/marketplace"  target="_blank" rel="noreferrer">
                <img src={Partnerts} alt="Official Minecraft Partner" className='ms-partners'/>
            </a>
        </div>
    </div>
  )
}

export default SomeText